export default "__VITE_PUBLIC_ASSET__b1338ac7__"